import { render, staticRenderFns } from "./SalariesDropdown.vue?vue&type=template&id=25f5c85a&scoped=true&"
import script from "./SalariesDropdown.vue?vue&type=script&lang=ts&"
export * from "./SalariesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5c85a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DropdownNationalHubsLayout: require('/root/project/frontend/src/components/navigation/main/DropdownNationalHubsLayout.vue').default})
